import { FontFamily } from '@common/theming/Fonts';
import { Palette } from '@common/theming/Palette';
import React from 'react';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

type ImageGalleryProps = {
  images: string[];
  initial?: number;
  onImageClick?: (slide: number) => void;
  maxImageWidth?: number;
};

export const ImageCarousel: React.FC<ImageGalleryProps> = ({
  images,
  initial = 0,
  onImageClick,
  maxImageWidth = 540,
}) => {
  return (
    <div>
      <Swiper
        pagination={{
          renderCustom: (swiper, current, total) => {
            return `<div style="display:flex; justify-content:center">
            <div style="border-radius: 15px ;padding-top:4px; padding-bottom:2px; font-size:14px; width:50px; background-color:rgba(0,0,0,0.6); color:${Palette.WHITE}; font-family:${FontFamily.NEUE_HAAS_DISPLAY_BOLD}">${current}/${total}</div>
            </div>`;
          },
          type: 'custom',
        }}
        modules={[Pagination]}
        spaceBetween={30}
        slidesPerGroupSkip={1}
        slidesPerView={1.3}
        centeredSlides={true}
        initialSlide={initial}>
        {images.map((image, i) => {
          return (
            <SwiperSlide key={`slide-${i}`}>
              <img
                onClick={() => {
                  if (onImageClick) {
                    onImageClick(i);
                  }
                }}
                style={{
                  borderRadius: 10,
                  height: window.innerWidth > maxImageWidth ? 270 : '45vw',
                  objectFit: 'cover',
                  width: '100%',
                }}
                src={image}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
